var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 37.46 49.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Degradado_sin_nombre_9-2);\n      }\n\n      .cls-2 {\n        fill: url(#Degradado_sin_nombre_9-10);\n      }\n\n      .cls-3 {\n        fill: url(#Degradado_sin_nombre_9-6);\n      }\n\n      .cls-4 {\n        fill: url(#Degradado_sin_nombre_9-4);\n      }\n\n      .cls-5 {\n        fill: url(#Degradado_sin_nombre_9-3);\n      }\n\n      .cls-6 {\n        fill: url(#Degradado_sin_nombre_9);\n      }\n\n      .cls-7 {\n        fill: url(#Degradado_sin_nombre_9-8);\n      }\n\n      .cls-8 {\n        fill: url(#Degradado_sin_nombre_9-9);\n      }\n\n      .cls-9 {\n        fill: url(#Degradado_sin_nombre_9-7);\n      }\n\n      .cls-10 {\n        fill: url(#Degradado_sin_nombre_9-5);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9",
    "data-name": "Degradado sin nombre 9",
    x1: 0,
    y1: 24.54,
    x2: 37.46,
    y2: 24.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#cd882d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#cd882d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#e1b45a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#edcf75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#f2da80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#ba8432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9-2",
    "data-name": "Degradado sin nombre 9",
    x1: 9.13,
    y1: 22.45,
    x2: 12.55,
    y2: 22.45,
    xlinkHref: "#Degradado_sin_nombre_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9-3",
    "data-name": "Degradado sin nombre 9",
    x1: 9.13,
    y1: 31.03,
    x2: 12.55,
    y2: 31.03,
    xlinkHref: "#Degradado_sin_nombre_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9-4",
    "data-name": "Degradado sin nombre 9",
    x1: 24.89,
    y1: 31.03,
    x2: 28.32,
    y2: 31.03,
    gradientTransform: "translate(57.62 4.41) rotate(89.96)",
    xlinkHref: "#Degradado_sin_nombre_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9-5",
    "data-name": "Degradado sin nombre 9",
    x1: 24.88,
    y1: 22.45,
    x2: 28.32,
    y2: 22.45,
    gradientTransform: "translate(49.03 -4.16) rotate(89.96)",
    xlinkHref: "#Degradado_sin_nombre_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9-6",
    "data-name": "Degradado sin nombre 9",
    x1: 17.01,
    y1: 22.46,
    x2: 20.43,
    y2: 22.46,
    xlinkHref: "#Degradado_sin_nombre_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9-7",
    "data-name": "Degradado sin nombre 9",
    x1: 17.01,
    y1: 31.03,
    x2: 20.43,
    y2: 31.03,
    xlinkHref: "#Degradado_sin_nombre_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9-8",
    "data-name": "Degradado sin nombre 9",
    x1: 9.13,
    y1: 39.61,
    x2: 12.55,
    y2: 39.61,
    xlinkHref: "#Degradado_sin_nombre_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9-9",
    "data-name": "Degradado sin nombre 9",
    x1: 24.89,
    y1: 39.61,
    x2: 28.32,
    y2: 39.61,
    gradientTransform: "translate(66.2 12.98) rotate(89.96)",
    xlinkHref: "#Degradado_sin_nombre_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9-10",
    "data-name": "Degradado sin nombre 9",
    x1: 17.01,
    y1: 39.62,
    x2: 20.43,
    y2: 39.62,
    xlinkHref: "#Degradado_sin_nombre_9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M26.58,1.45v.92s3.43,0,3.43,0l.03-.65c-.05-.9.41-1.61,1.09-1.71.64-.09,1.32.51,1.33,1.39l.02,1.26c2.82.99,4.97,4.21,4.97,7.97v30.12c0,4.54-3.05,8.33-6.69,8.33H6.72C3.14,49.09,0,45.43,0,40.9V10.48C0,6.06,3.05,2.54,6.47,2.37l.02-.9C6.52.63,7.09-.02,7.73,0s1.2.69,1.2,1.57v.8s3.44,0,3.44,0v-.89C12.4.64,12.97,0,13.59,0s1.21.63,1.23,1.47v.9s3.44,0,3.44,0l.02-.9c.02-.82.55-1.44,1.16-1.47s1.24.56,1.26,1.4l.02.96h3.44s0-.82,0-.82c0-.84.52-1.52,1.18-1.54s1.23.57,1.25,1.45ZM20.71,5.41l-.02.95c-.02.83-.63,1.4-1.25,1.37s-1.15-.63-1.16-1.44v-.88s-3.46,0-3.46,0v.8c0,.87-.56,1.53-1.22,1.52s-1.21-.66-1.21-1.53v-.8s-3.44,0-3.44,0v.78c-.02.86-.55,1.53-1.21,1.54s-1.21-.6-1.23-1.45l-.02-.87c-2.19.18-3.93,2.34-4.06,5.05-.03.6-.01,1.18,0,1.74h32.59s0-1.67,0-1.67c0-2.04-1.06-3.81-2.55-4.66.11.97-.38,1.76-1.11,1.85-.68.08-1.31-.6-1.31-1.52v-.8s-3.44,0-3.44,0v.85c-.02.85-.61,1.5-1.26,1.47s-1.18-.67-1.19-1.52v-.8s-3.45,0-3.45,0ZM31,46.04c2.19-.21,4.01-2.46,4.01-5.21V15.24s-32.59,0-32.59,0v25.67c.11,2.78,1.89,4.99,4.11,5.13h24.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.13,
    y: 20.32,
    width: 3.42,
    height: 4.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 9.13,
    y: 28.89,
    width: 3.42,
    height: 4.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 24.47,
    y: 29.32,
    width: 4.27,
    height: 3.42,
    transform: "translate(-4.44 57.62) rotate(-89.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 24.46,
    y: 20.74,
    width: 4.27,
    height: 3.44,
    transform: "translate(4.13 49.04) rotate(-89.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.01,
    y: 20.32,
    width: 3.42,
    height: 4.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 17.01,
    y: 28.89,
    width: 3.42,
    height: 4.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 9.13,
    y: 37.48,
    width: 3.43,
    height: 4.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 24.47,
    y: 37.9,
    width: 4.26,
    height: 3.42,
    transform: "translate(-13.02 66.19) rotate(-89.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.01,
    y: 37.48,
    width: 3.42,
    height: 4.28
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendario);
export default __webpack_public_path__ + "static/media/calendario.888d23616c887341fe500d289342c0ad.svg";
export { ForwardRef as ReactComponent };